"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const InputText_1 = __importDefault(require("@Components/Fields/InputText"));
const Dropdown_1 = __importDefault(require("@Components/Selectors/Dropdown"));
const validate_1 = require("@App/helpers/validate");
const tooltip_text_1 = require("@Const/tooltip-text");
const regexp_1 = require("@Const/regexp");
const get_value_form_1 = require("@App/helpers/get-value-form");
const entities_validators_1 = require("@App/helpers/work-entities/entities-validators");
const removers_1 = require("@App/helpers/work-entities/removers");
const work_entities_fields_validators_1 = require("@App/helpers/work-entities-fields-validators");
const contexts_1 = require("@App/contexts");
const AddAlternativeTitlesSidebar_1 = __importDefault(require("@Components/Sidebars/AddAlternativeTitlesSidebar"));
const TablesForm_1 = __importDefault(require("@Components/ViewWork/Table/TablesForm"));
const AlternativeTitlesTableInfo_1 = __importDefault(require("@Scenes/WorkScenes/Steps/WorkDetailsStep/AlternativeTitlesTableInfo"));
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const WorkDetailsStep = () => {
    const presetData = () => {
        const workDraftFromLocal = workStore.workDraftLocal;
        if (!workDraftFromLocal) {
            return;
        }
        const workDetailsData = {
            title: workDraftFromLocal.title,
            duration: workDraftFromLocal.duration,
            languageCode: workDraftFromLocal.languageCode,
            copyrightOfficeNumber: workDraftFromLocal.copyrightOfficeNumber,
            copyrightOfficeDate: workDraftFromLocal.copyrightOfficeDate,
            firstUseRefusalIndicator: workDraftFromLocal.firstUseRefusalIndicator,
            rightsholderProprietaryId: workDraftFromLocal.rightsholderProprietaryId,
            iswc: workDraftFromLocal.iswc,
        };
        return workDetailsData;
    };
    const setValidations = () => {
        const { title, duration, languageCode, copyrightOfficeDate, rightsholderProprietaryId, iswc } = workDetails;
        return {
            title: {
                pipeFunction: work_entities_fields_validators_1.workTitleInvalidCheck,
                error: !title
                    ? 'Required'
                    : title.length > 200
                        ? `Invalid value, max length 200`
                        : (0, work_entities_fields_validators_1.containsNewLine)(title)
                            ? 'May not include multiple lines'
                            : '',
            },
            duration: {
                isDuration: true,
                error: !duration || duration.match(/^[0-9]{2}[:]{1}[0-9]{2}$/)
                    ? ''
                    : 'Enter the duration in the format 00:00',
            },
            languageCode: {
                // required: false,
                isLanguage: true,
                error: !languageCode ? 'Please select language' : '',
            },
            copyrightOfficeNumber: {
                maxLength: 12,
            },
            copyrightOfficeDate: {
                isDate: true,
                error: !copyrightOfficeDate || copyrightOfficeDate.match(regexp_1.DATE_REGEX)
                    ? ''
                    : 'Enter the date in format YYYY-MM-DD',
            },
            firstUseRefusalIndicator: {
                required: true,
            },
            rightsholderProprietaryId: {
                maxLength: 14,
                error: rightsholderProprietaryId && rightsholderProprietaryId.length > 14
                    ? `Invalid value, max length 14`
                    : '',
            },
            iswc: {
                isISWC: true,
                error: !iswc || (0, validate_1.ISWCValidator)(iswc) ? '' : 'Invalid ISWC',
            },
        };
    };
    const { workStore, libStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [workDetails, setWorkDetails] = (0, react_1.useState)(() => (Object.assign({}, presetData())));
    const [validation, setValidation] = (0, react_1.useState)(() => setValidations());
    const [sidebarIsOpen, setSidebarIsOpen] = (0, react_1.useState)(false);
    const getValues = (value, id) => {
        const data = (0, get_value_form_1.getValueForm)(value, id, workDetails, validation);
        setWorkDetails(data.formObject);
        setValidation(data.validationObject);
        setUpdatedWorkDetailsToDraft();
    };
    const setUpdatedWorkDetailsToDraft = () => {
        const workDraftFromLocal = workStore.workDraftLocal;
        if (!workDraftFromLocal) {
            return;
        }
        const updatedWorkDraft = Object.assign(Object.assign(Object.assign({}, workDraftFromLocal), workDetails), { iswc: (workDetails === null || workDetails === void 0 ? void 0 : workDetails.iswc) ? workDetails.iswc.replace(/-/g, '').replace(/\./g, '') : null });
        workStore.setWorkDraftToLocal(updatedWorkDraft);
        stepValidator();
    };
    const removeAlternativeTitle = (removingTitle) => {
        const workDraftFromLocal = workStore.workDraftLocal;
        if (!workDraftFromLocal) {
            return;
        }
        const updatedWorkDraft = (0, removers_1.akaTitleRemover)(removingTitle, workDraftFromLocal);
        workStore.setWorkDraftToLocal(updatedWorkDraft);
        stepValidator();
    };
    const stepValidator = () => {
        const workDraftFromLocal = workStore.workDraftLocal;
        if (!workDraftFromLocal) {
            return;
        }
        const invalid = (0, entities_validators_1.workDetailsInvalidCheck)(workDraftFromLocal, libStore.akaTitleTypes, libStore.languages);
        workStore.setWizardStepValidation(!invalid);
    };
    const openSidebar = () => {
        setSidebarIsOpen(true);
    };
    const closeSidebar = () => {
        setSidebarIsOpen(false);
    };
    (0, react_1.useEffect)(() => {
        stepValidator();
    }, []);
    const languageOptions = libStore.languages;
    const workDraftFromLocal = workStore.workDraftLocal;
    if (!workDetails || !validation || !workDraftFromLocal || !languageOptions) {
        return null;
    }
    const { title, duration, languageCode, rightsholderProprietaryId, iswc } = workDetails;
    return (react_1.default.createElement("div", { className: "work-details-step" },
        react_1.default.createElement("div", { className: "details-create-work-wizard" },
            react_1.default.createElement("h6", null, "Enter Work Details"),
            react_1.default.createElement("div", { className: "normal" },
                react_1.default.createElement("span", null, "Enter work details for "),
                react_1.default.createElement("span", { title: workDraftFromLocal.title },
                    "\u2018",
                    react_1.default.createElement("span", null, workDraftFromLocal.title),
                    "\u2019"),
                react_1.default.createElement("span", null, " below.")),
            react_1.default.createElement("div", { className: "inputs-field" },
                react_1.default.createElement("div", { className: 'title-area' },
                    react_1.default.createElement(InputText_1.default, { mainColor: true, id: 'title', label: 'Work Title', assistiveText: 'Required', value: title, onChange: getValues, errorMessage: validation.title.error, required: validation.title.required, disabled: !!(workDraftFromLocal.id && workDraftFromLocal.isComplete), isEscapeNewlines: true })),
                react_1.default.createElement(Dropdown_1.default, { options: languageOptions, id: 'languageCode', placeholder: 'Language', label: 'Language', mainColor: true, onChange: getValues, isNumberType: true, isSearchable: true, selectedValue: languageCode ? languageOptions.find((option) => +option.id === languageCode) : null }),
                react_1.default.createElement(InputText_1.default, { mainColor: true, id: 'iswc', label: 'ISWC', value: iswc, onChange: getValues, errorMessage: validation.iswc.error, required: validation.iswc.required, helperTitleText: tooltip_text_1.TOOLTIP_TEXT.createWork.iswc, helperType: '?' }),
                react_1.default.createElement(InputText_1.default, { mainColor: true, id: 'duration', label: 'Duration', value: duration ? duration : '', onChange: getValues, errorMessage: validation.duration.error, required: validation.duration.required }),
                react_1.default.createElement(InputText_1.default, { mainColor: true, id: 'rightsholderProprietaryId', label: 'Member Work Identifier', value: rightsholderProprietaryId, onChange: getValues, errorMessage: validation.rightsholderProprietaryId.error, required: validation.rightsholderProprietaryId.required, helperTitleText: tooltip_text_1.TOOLTIP_TEXT.createWork.rightsholderProprietaryId, helperType: '?' }))),
        react_1.default.createElement(TablesForm_1.default, { className: 'alternative-titles-table', headingDecoration: {
                icon: 'writers',
                title: 'Alternative Titles',
                required: false,
                toolTip: react_1.default.createElement(CustomToolTip_1.default, { inverse: true, type: '?', info: tooltip_text_1.TOOLTIP_TEXT.createWork.alternativeTitles }),
            }, tableInfos: (0, AlternativeTitlesTableInfo_1.default)(), addButtonTitle: 'Add Alternative Title', onAddButtonClicked: () => {
                openSidebar();
            }, onRemoveCellClicked: (index) => {
                removeAlternativeTitle(workDraftFromLocal.alternativeTitles[index]);
            }, useAlternateHeader: true }),
        react_1.default.createElement(AddAlternativeTitlesSidebar_1.default, { open: sidebarIsOpen, onClose: closeSidebar })));
};
exports.default = (0, mobx_react_1.observer)(WorkDetailsStep);
